/**
 * Bus Services Index
 * Tüm otobüs servislerini export eder
 */

import { busBasicService } from './basic';
import { busHomeService } from './home';
import { busRouteService } from './route';
import { busCityService } from './city';
import { busSearchService } from './search';
import { busSalesService } from './sales';
import { busAuthService } from './auth';
import { busCompanyService } from './company';
import { busStationService } from './station';
// Individual service exports
export { busBasicService };
export { busHomeService };
export { busRouteService };
export { busCityService };
export { busSearchService };
export { busSalesService };
export { busAuthService };
export { busCompanyService };
export { busStationService };

/**
 * Tüm servisleri tek obje olarak export et
 */
export const busServices = {
  basic: busBasicService,
  home: busHomeService,
  route: busRouteService,
  city: busCityService,
  search: busSearchService,
  sales: busSalesService,
  auth: busAuthService,
  company: busCompanyService,
  station: busStationService,
};

export default busServices;